
import React from "react";
import CountUp from "react-countup";
import { UserCheck, PiggyBank, AlertTriangle, Percent } from "lucide-react";
import { Summary } from "../../../../components/ui/Summary";
import { SubscriptionIndicatorController } from "../../../../services/controllers/subscription";
import { useIndicators } from "../../../../store/subscription/useIndicators";
import { formatMoney } from "../../../../services/functions";


export function DashboardSummary() {
  const {
    subscribers,
    invoicing,
    cancellations,
    margin,
  } = useIndicators(st => st.data)

  const CLSubscriptionIndicator = SubscriptionIndicatorController()
  CLSubscriptionIndicator.init()

  const subscribersData = subscribers || {}
  const invoicingData = invoicing || {}
  const cancellationsData = cancellations || {}
  const marginData = margin || {}

  // if (!subscribers) CLSubscriptionIndicator.getSubscribers()
  // if(!invoicing) CLSubscriptionIndicator.getInvoicing()
  // if(!cancellations) CLSubscriptionIndicator.getCancellations()
  // if(!margin) CLSubscriptionIndicator.getMargin()

  return (
    <Summary.Root>
      <Summary.Box status={subscribersData.assinantes >= subscribersData.meta ? 'up' : 'down'}>
        <Summary.Icon icon={UserCheck} />
        <Summary.TextContent>
          <Summary.Title size='big'>
            <CountUp
              end={subscribersData.assinantes || 0}
              preserveValue
              useEasing
            />
          </Summary.Title>
          <Summary.Text>Total de Assinantes</Summary.Text>
          <Summary.SubTitle>Meta: {subscribersData.meta || 0}</Summary.SubTitle>
        </Summary.TextContent>
      </Summary.Box>
      <Summary.Box status={invoicingData.receitaTotal >= invoicingData.meta ? 'up' : 'down'}>
        <Summary.Icon icon={PiggyBank} />
        <Summary.TextContent>
          <Summary.Title size='big'>
            R${" "}
            <CountUp
              end={invoicingData.receitaTotal || 0}
              separator="."
              decimals={2}
              decimal=","
              preserveValue
              useEasing
            />
          </Summary.Title>
          <Summary.Text>Faturamento</Summary.Text>
          <Summary.SubTitle>Meta: R$ {formatMoney(invoicingData.meta || 0)}</Summary.SubTitle>
        </Summary.TextContent>
      </Summary.Box>
      <Summary.Box status={cancellationsData.cancelamentos <= cancellationsData.meta ? 'up' : 'down'}>
        <Summary.Icon icon={AlertTriangle} />
        <Summary.TextContent>
          <Summary.Title size='big'>
            <CountUp
              end={cancellationsData.cancelamentos || 0}
              decimals={0}
              preserveValue
              useEasing
            />
          </Summary.Title>
          <Summary.Text>Cancelamentos</Summary.Text>
          <Summary.SubTitle>Limite: {cancellationsData.meta || 0}</Summary.SubTitle>
        </Summary.TextContent>
      </Summary.Box>
      <Summary.Box status={marginData.margem >= marginData.meta ? 'up' : 'down'}>
        <Summary.Icon icon={Percent} />
        <Summary.TextContent>
          <Summary.Title size='big'>
            <CountUp
              end={marginData.margem || 0}
              decimals={0}
              preserveValue
              useEasing
            />%
          </Summary.Title>
          <Summary.Text>Margem</Summary.Text>
          <Summary.SubTitle>Referência: {(marginData.meta || 0) * 100}%</Summary.SubTitle>
        </Summary.TextContent>
      </Summary.Box>
    </Summary.Root>
  )
}
